export const CONTACT_FIELDS = {
  NAME_1: "first_name",
  NAME_2: "last_name",
  EMAIL: "email",
  PHONE_1: "home_phone",
  PHONE_2: "cell_phone",
  UNIQUE_ID: "ssn",
  START_DATE: "born_on"
};

export const ADDRESS_FIELDS = {
  STREET_1: "street1",
  STREET_2: "street2",
  CITY: "city",
  STATE: "state",
  ZIP: "zip",
  LATITUDE: "latitude",
  LONGITUDE: "longitude",
  GOOGLE_PLACE_ID: "google_place_id"
};

// NAME_1 == name (aka DBA)
// NAME_2 == legal_name
export const ACCOUNT_FIELDS = {
  TYPE: "entity_type",
  NAME_1: "name",
  START_DATE: "started_on",
  NAME_2: "legal_name",
  PHONE_1: "phone",
  EMAIL: "email",
  WEBSITE: "website",
  UNIQUE_ID: "fein",
  REVENUE: "monthly_revenue",
  INDUSTRY_NAME: "industry_name"
};

export const APPLICATION_FIELDS = {
  HAS_CURRENT_LOAN: "has_current_loan",
  APPLICANT_IS_OWNER: "applicant_is_owner",
  LOAN_USE: "loan_use",
  CAPITAL_NEEDED: "capital_needed",
  OWNERINFOPERCENT_1: "ownerInfo1_percent_ownership",
  OWNERINFOPERCENT_2: "ownerInfo2_percent_ownership",
  NOTES: "notes"
};
